module.exports = __webpack_public_path__ + "static/media/logo.a49bbe2d.png";